import { MaskLine } from "@/components/motion";

export const PageHero = ({ eyebrow, title, text, image }) => (
  <section className="grain relative overflow-hidden pt-32 pb-16 lg:pt-40" data-testid="page-hero">
    {image && (
      <>
        <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#070C1A]/70 via-[#070C1A]/85 to-[#070C1A]" />
      </>
    )}
    <div className="container-x relative">
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-[var(--gold)]">{eyebrow}</p>
      <h1 className="font-display mt-4 text-5xl font-black uppercase leading-[0.9] sm:text-7xl lg:text-8xl" data-testid="page-title">
        <MaskLine>{title}</MaskLine>
      </h1>
      {text && <p className="mt-6 max-w-2xl text-[var(--steel)]">{text}</p>}
    </div>
  </section>
);
